import { Id, Identifiable, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function moveKanbanTask(httpClient: HttpClient) {
  return (task: Identifiable<Task>, after: { uuid: Id } | null) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/project-elements/TASK/${task.uuid}/move-in-kanban`,
        method: HttpMethods.POST,
        data: {
          after: after
            ? {
                type: "TASK",
                id: after.uuid,
              }
            : null,
        },
      })
      .catch((e) => Promise.reject(mapError(e, { notFound: "notFound" })));
}

export { moveKanbanTask };
